/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Save_FailedInputs */



/**
* | output |
* | --- |
* | "Could not save that change. Try again." |
*
* @param {Settings_Save_FailedInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const settings_save_failed = /** @type {((inputs?: Settings_Save_FailedInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Save_FailedInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Die wijziging kon niet bewaard worden. Probeer opnieuw.")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Cette modification n'a pas pu être enregistrée. Réessayez.")
	return /** @type {LocalizedString} */ ("Could not save that change. Try again.")
});